import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, filter } from 'rxjs';
import { BusinessUserResource } from 'src/app/interfaces/business-user-resource';
import { supplyContract } from 'src/app/interfaces/supplyContract';
import { BusinessuserService } from 'src/app/services/businessuser.service';
import { OverlayService } from 'src/app/services/overlay.service';

@Component({
  selector: 'app-contracts',
  templateUrl: './contracts.component.html',
  styleUrls: ['./contracts.component.scss']
})
export class ContractsComponent implements OnInit {
  /**
   * The Columns of the Table
   */
  displayedColumns: string[] = ['count', 'contractType', 'contractState', 'number', 'measuringPointNumber', 'validFrom', 'validUntil', 'locallyManaged', 'menu'];
  /**
   * The data to be displayed in the Table
   */
  dataSource;
  /**
   * the current user as an Object => set via URL
   */
  currentUser: BusinessUserResource;
  /**
   * The Form to filter the Contracts
   */
  filterForm: UntypedFormGroup;
  /**
   * is the page loading
   */
  loading: boolean = true;
  /***
   * the current Page of Contracts
   */
  page;
  /**
   * PagemetaData
   */
  pageData = {
    page: 0,
    size: 12
  }
  /**
   * The States of contracts
   */
  supplyContractState = [
    { value: 'NEW', viewValue: 'Neu', 'state': true },
    { value: 'RUNNING', viewValue: 'Läuft', 'state': true },
    { value: 'CANCELLED', viewValue: 'Gekündigt', 'state': true },
    { value: 'FINISHED', viewValue: 'Beendet', 'state': true },
  ]
  /**
   * The Types of contracts
   */
  SupplyContractType = [
    { value: 'UNKNOWN', viewValue: 'unbekannt', 'state': true },
    { value: 'POWER', viewValue: 'Strom', 'state': true },
    { value: 'GAS', viewValue: 'Gas', 'state': true },
    { value: 'WATER', viewValue: 'Wasser', 'state': true },
    { value: 'CABLE', viewValue: 'Kabel', 'state': true },
    { value: 'MOBILE', viewValue: 'Mobil', 'state': true },
    { value: 'HEAT', viewValue: 'Wärme', 'state': true },
    { value: 'PHOTOVOLTAIK', viewValue: 'Photovoltaik', 'state': true },
    { value: 'FIBER', viewValue: 'Glasfaser', 'state': true },
    { value: 'GARDENWATER', viewValue: 'Gartenwasser', 'state': true },
  ]
  /**
   * constructor
   * Init the Form
   * @param businessuserService 
   * @param route 
   * @param overlay 
   * @param fb 
   * @param router 
   */
  constructor(
    private businessuserService: BusinessuserService,
    private route: ActivatedRoute,
    private overlay: OverlayService,
    private fb: UntypedFormBuilder,
    private router: Router) {

    this.filterForm = this.fb.group({
      filterByStates: [[]],
      filterByTypes: [[]]
    })
  }
  /**
   * Load the Page of filterd Contracts
   * @param event 
   */
  loadPage(event?: PageEvent) {
    this.page.pageIndex = event.pageIndex;
    this.page.pageSize = event.pageSize;
    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: {
          page: event.pageIndex,
          size: event.pageSize,
        },
        queryParamsHandling: 'merge'
      }).then(() => {
        return this.search(event.pageIndex, event.pageSize);
      })
  }
/**
 * Get the page of filtered Contracts
 * @param pageIndex 
 * @param pageSize 
 */
  search(pageIndex, pageSize) {
    this.loading = true;
    this.businessuserService.searchForContract(pageIndex, pageSize, this.currentUser.publicId, this.filterForm.value.filterByStates, this.filterForm.value.filterByTypes).subscribe({
      next: (filterRes: any) => {
        this.page = filterRes.page;
        //Filter out Account from  List of Supplycontracts
        this.page.totalElements = filterRes.page.totalElements - 1;
        this.dataSource = new MatTableDataSource(filterRes.content.filter(contract => contract.contractType != "ACCOUNT"));
        this.loading = false;
      },
      error: err => {
        console.log(err)
      }
    })
  }
  /**
   * ngOnInit
   * set the current User
   */
  ngOnInit(): void {
    this.route.params.subscribe(params => {
      combineLatest([
        this.businessuserService.getBuissnessUser(params['id']),
      ]).subscribe(([user]: [BusinessUserResource]) => {
        this.currentUser = user;
        this.search(this.pageData.page, this.pageData.size);
      })
    })
  }
  /**
   * Edit the locallyManaged of a Contract
   * @param contract 
   * @param locallyManaged 
   */
  editContractForUser(contract: supplyContract, locallyManaged) {
    contract.locallyManaged = locallyManaged;
    this.businessuserService.editContractForUser(this.currentUser.publicId, contract).subscribe({
      next: () => {
        this.overlay.openSnackBar("Vertrag erfolgreich geändert!");
      },
      error: err => {
        console.log(err)
      }
    })
  }
  /**
   * Delete a Contract after the Dialog is confirmed
   * @param contract 
   */
  delete(contract: supplyContract) {
    this.overlay.openDeleteInterptorDialog("Wirklich löschen?", "Soll dieser Vertrag wirklich gelöscht werden?", "Löschen", "Abbrechen").subscribe((shouldDelete: boolean) => {
      if (shouldDelete === true) {
        this.businessuserService.deleteContractFromUser(this.currentUser.publicId, contract).subscribe({
          next: () => {
            this.overlay.openSnackBar("Vertrag erfolgreich gelöscht!");
            this.ngOnInit();
          },
          error: err => {
            console.log(err)
          }
        })
      }
    })
  }
  /**
   * Reset the Filter and load the unfiltered Contracts
   */
  resetFilter() {
    this.filterForm.reset();
    this.ngOnInit();
  }
  /**
   * Filter the Contracts
   */
  filterContracts() {
    this.search(this.pageData.page, this.pageData.size);
  }
}